import React, { Component } from 'react';
import PropTypes from 'prop-types';
import io from 'socket.io-client';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Fa from 'react-fontawesome';

import { getUser, getUserCurrentOrganization } from '../Auth/AuthReducer';

class SocketConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getChildContext() {
    this.setupSocket();
    return {
      socket: this.socket || {
        emit: () => {},
        on: () => {},
      },
    };
  }

  componentDidMount() {
    this.setupSocket();
    /*
    if (this.socket) {
      this.socket.emit('join-organization');
      this.socket.emit('join-admin');
    }
    */
  }

  componentWillReceiveProps(nextProps) {
    const nextUser = nextProps.user;
    const currentUser = this.props.user;
    const nextOrg = nextProps.userCurrentOrganization;
    const currentOrg = this.props.userCurrentOrganization || {};
    if (!nextUser) {
      this.updateSocketToken(null);
    } else if (nextUser.$token !== currentUser.$token) {
      this.updateSocketToken(nextUser.$token);
      this.socket.emit('join-organization');
      this.socket.emit('join-admin');
    } else if (nextOrg && nextOrg._id !== currentOrg._id) {
      this.socket.emit('join-organization');
    }
  }




  componentWillUnmount() {
    this.updateSocketToken(null);
  }

  setupSocket() {
    if (typeof document !== 'undefined') {
      if (!this.socket) {
        const node = process.env.REACT_APP_SOCKET_NODE || 'local';
        let toastId = null;
        let attempt = 0;

        const socket = io(`/${node}`, {
          query: {
            token: this.props.user ? this.props.user.$token : null,
          },
          path: '/socket.io',
          transports: ['websocket'],
          secure: true,
        });

        const toasterClose = () => {
          toastId = null;
        }

        socket.on('connect', (reason) => {
          socket.emit('join-organization');
          socket.emit('join-admin');
          attempt = 0;
          if (toastId) {
            const el = (<div>Socket re-connected!</div>);
            if (toastId) {
              toast.update(toastId, { 
                render: () => el,
                type: 'success',
                autoClose: true,
                onClose: toasterClose,
              });
            } else {
              toastId = this.context.addNotification(el, { type: 'success', autoClose: true, onClose: toasterClose });
            }
            //this.context.addNotification(el, { type: 'success', autoClose: true });
            // toast.dismiss(toastId);
            // toastId = null;
          }
        });
        socket.on('reconnect_attempt', () => {
          console.log('SOCKET', 'reconnect_attempt');
          attempt += 1;
          const el = (<div><Fa name="spinner" spin /> Reconnect Attempt ({attempt})...</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
          }
          this.updateSocketToken(this.props.user ? this.props.user.$token : null);
        });

        /*
        socket.on('reconnection_attempt', () => {
          console.log('SOCKET', 'reconnection_attempt')
          this.updateSocketToken(this.props.user ? this.props.user.$token : null);
        });
        */
        socket.on('disconnect', (reason) => {
          const el = (<div>Socket disconnected. Please refresh the page.</div>);
          if (!toastId) {
            toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
          }
        });
        
        this.socket = socket;
      }
      return this.socket;
    }
    return null;
  }

  updateSocketToken(token) {
    if (this.socket && this.socket.io) {
      this.socket.io.opts.query = {
        ...this.socket.io.opts.query,
        token,
      };
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

SocketConnector.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.string,
    $token: PropTypes.string,
  }).isRequired,
  children: PropTypes.node,
  userCurrentOrganization: PropTypes.shape({}),
};
SocketConnector.defaultProps = {
  children: null,
  userCurrentOrganization: null,
};
SocketConnector.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
SocketConnector.childContextTypes = {
  socket: PropTypes.shape({}),
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    userCurrentOrganization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(SocketConnector);
